import React from 'react'
import { map } from 'lodash'
import { Grid, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'
import Card from 'components/Card/Card.jsx'
import { db, storage, keygen } from '../../services/firebase'
import Modal from 'components/Modal/Modal.jsx'
import SweetAlert from 'react-bootstrap-sweetalert'
import { compress, readImage } from '../../services/compressor'
import Button from 'elements/CustomButton/CustomButton.jsx'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import SweetSpinner from 'components/SweetSpinner/SweetSpinner.jsx'
import BannerForm from 'forms/BannerForm.jsx'
import './Banners.css'

export default class Banners extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            banners: [],
            loading: false,
            isModalVisible: false,
            alert: null
        }

        this.user = props.user
        this.resetForm = props.resetForm
        this.submitForm = props.submitForm
        this.notify = props.notify
    }

    componentDidMount() {
        this._fetchBanners()
    }

    render() {
        const { alert } = this.state
        return (
            <div className='main-content'>
                {alert}
                {this.bannerModal()}
                <Card content={
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Button
                                    bsStyle='default'
                                    wd
                                    className='pull-right'
                                    style={{ marginBottom: 10 }}
                                    onClick={() => {
                                        // this.props.resetForm('FabricForm')
                                        this.setState({ isModalVisible: true })
                                    }}
                                >
                                    Adicionar Banner
                        </Button>
                            </Col>
                        </Row>
                        {this._handleContent()}
                    </Grid>
                } />
            </div>
        )
    }

    bannerModal = _ => {
        const { isModalVisible } = this.state
        return (
            <Modal
                // size='modal__big'
                title='Novo Banner'
                isOpen={isModalVisible}
                content={
                    <BannerForm
                        onSubmit={values => this._handleSubmit(values)}
                        handleCancel={() => this.setState({ isModalVisible: false })}
                    />
                }
            />
        )
    }

    _handleContent = _ => {
        const { loading, banners } = this.state

        if (loading && !banners.length) {
            return (
                <Row>
                    <span className='banners__message'>Buscando banners...</span>
                </Row>
            )
        }

        if (!loading && !banners.length) {
            return (
                <Row>
                    <span className='banners__message'>Nenhum banner cadastrado.</span>
                </Row>
            )
        }

        if (!loading && banners.length) {
            return (
                <Row>
                    {map(banners, (banner, index) => (
                        <Col lg={3} md={4} sm={6} xs={12} className='banner__frame' key={index}>
                            <img src={banner.downloadURL} alt='banner' className='banner__image' />
                            <div className='banner__delete'>
                                <OverlayTrigger
                                    placement='top'
                                    overlay={(<Tooltip id={`edit_${index}`}>Remover</Tooltip>)}
                                >
                                    <a
                                        className='btn btn-simple btn-default btn-icon'
                                        onClick={() => this.removeBannerAlert(banner)}
                                    >
                                        <FontAwesomeIcon className='text-danger' icon='trash' />
                                    </a>
                                </OverlayTrigger>
                            </div>
                        </Col>
                    ))}
                </Row>
            )
        }
    }

    _handleSubmit = async values => {
        this.setState({ isModalVisible: false })
        this.waitAlert('Adicionando banner', true)

        const extension = this._handleExtension(values.image)

        if (extension) {
            const key = keygen()
            const imageName = `${key}.${extension}`
            const receivedImage = await readImage(values.image)
            const compressedImage = await this._compressImage(receivedImage)
            const uploadedImage = await this._uploadImage(compressedImage, imageName)

            db.collection('banners').doc(key).set({ downloadURL: uploadedImage.downloadURL, imageName })
                .then(() => {
                    this.hideAlert()
                    this.props.notify('Banner adicionado.', 'success')
                    this.props.resetForm('BannerForm')
                })
                .catch(e => {
                    this.hideAlert()
                    this.props.notify('Erro ao adicionar banner.', 'error')
                    this.setState({ isModalVisible: true })
                })

        } else {
            this.hideAlert()
            this.props.notify('O arquivo selecionado não é uma imagem.', 'error')
        }
    }

    _removeBanner = banner => {
        this.waitAlert('Removendo banner', false)
        db.collection('banners').doc(banner.id).delete()
            .then(() => {
                storage.ref().child(`banners/${banner.imageName}`).delete()
                    .then(() => {
                        this.hideAlert()
                        this.props.notify('Banner removido.', 'success')
                        this.props.notify('Se o banner ainda aparecer na lista, atualize a página.', 'info')
                    })
                    .catch(e => {
                        this.hideAlert()
                        this.props.notify('Erro ao remover banner.', 'error')
                    })
            })
            .catch(e => {
                this.hideAlert()
                this.props.notify('Erro ao remover banner.', 'error')
            })
    }

    _compressImage = async image => await compress(image)

    _uploadImage = async (image, name) => await storage.ref().child(`banners/${name}`).put(image)

    _removeImage = async name => await storage.ref().child(`banners/${name}`).delete()

    _handleExtension = image => {
        let type = image.type.split('/')
        switch (type[1]) {
            case 'jpeg':
            case 'jpg':
                return 'jpg'
            case 'png':
                return 'png'
            default:
                return null
        }
    }

    _fetchBanners = () => {
        this.setState({ loading: true })
        db.collection('banners').onSnapshot(snapshot =>
            !snapshot.empty
                ? this._passBannersToState(snapshot)
                : this.setState({ loading: false })
        )
    }

    _passBannersToState = snapshot => {
        const banners = []
        snapshot.forEach(s => banners.push({ ...s.data(), id: s.id }))
        return this.setState({ loading: false, banners })
    }

    hideAlert = () => this.setState({ alert: null })

    waitAlert = (title, showSpinner) => {
        this.setState({
            alert: (
                <SweetAlert
                    style={{ display: 'block' }}
                    title={title}
                    onConfirm={() => null}
                    showConfirm={false}
                >
                    {showSpinner ? (<SweetSpinner />) : null}
                </SweetAlert>
            )
        })
    }

    removeBannerAlert = banner => {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block" }}
                    title="Tem certeza?"
                    onConfirm={() => this._removeBanner(banner)}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="default"
                    cancelBtnBsStyle="warning"
                    confirmBtnText="Continuar"
                    cancelBtnText="Cancelar"
                    showCancel
                />
            )
        });
    }

}


// WEBPACK FOOTER //
// ./src/views/Banners/Banners.jsx